module.exports = "pegasus_template/assets/square-twitter.png";